// extracted by mini-css-extract-plugin
module.exports = {"closedBetLine":"ClosedBetLine_closedBetLine__2ppMC","closedBadge":"ClosedBetLine_closedBadge__1XGtz"};